/* ============================================================
   Siora — Cash-on-Delivery order form. Reads a per-product config
   (<script data-cod-config>), opens a popup, and on submit POSTs to
   the backend Worker which creates a real Admin order (write_orders).
   No dependencies. Self-initialising.
   ============================================================ */
(function () {
  'use strict';
  var CFG = null, MODAL = null, EL = {}, state = { variant: null, qty: 1, offer: null, busy: false, coupon: null, couponBusy: false };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = (CFG && CFG.money_format) || '';
    var amt = (cents / 100);
    var withCommas = amt.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var noDec = Math.round(amt).toLocaleString('en-US');
    if (fmt && /\{\{\s*amount/.test(fmt)) {
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
                .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
                .replace(/<[^>]+>/g, '').trim();
    }
    return 'Rs.' + withCommas;
  }

  /* ---------- parse qty offers: "qty | label | tag" per line ---------- */
  function parseOffers(str) {
    if (!str) return [];
    return String(str).split(/\r?\n/).map(function (line) {
      var p = line.split('|').map(function (x) { return x.trim(); });
      var q = parseInt(p[0], 10);
      if (!q || q < 1) return null;
      return { qty: q, label: p[1] || ('Buy ' + q), tag: p[2] || '' };
    }).filter(Boolean).sort(function (a, b) { return a.qty - b.qty; });
  }

  /* ---------- does this offer copy promise free shipping? ---------- */
  function claimsFreeShip(txt) { return /free\s*(-|\s)?\s*ship/i.test(String(txt || '')); }

  /* ---------- shipping cost for a given line total (same rule as the totals row) ---------- */
  function shipFor(total) {
    var freeOver = CFG.free_ship_over || 0;
    return (freeOver > 0 && total >= freeOver) ? 0 : (CFG.shipping || 0);
  }

  /* ---------- build the modal once ---------- */
  function buildModal() {
    if (MODAL) return;
    MODAL = document.createElement('div');
    MODAL.className = 'cod-modal';
    MODAL.setAttribute('role', 'dialog');
    MODAL.setAttribute('aria-modal', 'true');
    MODAL.innerHTML =
      '<div class="cod-modal__scrim" data-cod-close></div>' +
      '<div class="cod-modal__card">' +
        '<div class="cod-head"><div class="cod-head__t"><h3></h3><p></p></div>' +
          '<button class="cod-x" type="button" data-cod-close aria-label="Close">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="m6 6 12 12M18 6 6 18"/></svg></button></div>' +
        '<div class="cod-body">' +
          '<div class="cod-prod"><img alt=""><div class="cod-prod__i"><b></b><div class="cod-var"></div></div><div class="cod-prod__p"><span class="was"></span><span class="now"></span></div></div>' +
          '<div class="cod-variants"></div>' +
          '<div class="cod-qtyrow"><span>Quantity</span><div class="cod-stepper"><button type="button" data-cod-dec aria-label="Decrease">−</button><input type="number" min="1" value="1" data-cod-qty inputmode="numeric"><button type="button" data-cod-inc aria-label="Increase">+</button></div></div>' +
          '<div class="cod-offers"></div>' +
          '<form class="cod-form" novalidate>' +
            '<div class="cod-field"><label>Full name <span class="req">*</span></label><input name="name" autocomplete="name" placeholder="e.g. Ayesha Khan"><small class="cod-field__err">Please enter your name</small></div>' +
            '<div class="cod-field"><label>Phone number <span class="req">*</span></label><input name="phone" type="tel" autocomplete="tel" inputmode="tel" placeholder="03XX XXXXXXX"><small class="cod-field__err">Enter a valid phone number</small></div>' +
            '<div class="cod-field"><label>Complete address <span class="req">*</span></label><textarea name="address" autocomplete="street-address" placeholder="House #, street, area…"></textarea><small class="cod-field__err">Please enter your address</small></div>' +
            '<div class="cod-row">' +
              '<div class="cod-field half"><label>City <span class="req">*</span></label><input name="city" autocomplete="address-level2" placeholder="e.g. Lahore"><small class="cod-field__err">Enter your city</small></div>' +
              '<div class="cod-field half" data-cod-province><label>Province</label><select name="province"></select></div>' +
            '</div>' +
            '<div class="cod-field" data-cod-email><label>Email <span class="req">*</span></label><input name="email" type="email" autocomplete="email" placeholder="you@email.com"><small class="cod-field__err">Please enter a valid email</small></div>' +
            '<div class="cod-field" data-cod-notes><label>Order notes (optional)</label><textarea name="notes" placeholder="Landmark, preferred delivery time…"></textarea></div>' +
            '<div class="cod-coupon" data-cod-coupon>' +
              '<label for="cod-coupon-input">Discount code</label>' +
              '<div class="cod-coupon__row">' +
                '<input id="cod-coupon-input" type="text" name="discount_code" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="Enter code" data-cod-code>' +
                '<button type="button" class="cod-coupon__btn" data-cod-apply>Apply</button>' +
              '</div>' +
              '<p class="cod-coupon__msg" data-cod-coupon-msg role="status" aria-live="polite"></p>' +
            '</div>' +
            '<input type="text" name="company" tabindex="-1" autocomplete="off" style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0" aria-hidden="true">' +
          '</form>' +
        '</div>' +
        '<div class="cod-foot">' +
          '<p class="cod-msg"></p>' +
          '<div class="cod-totals"><div class="r"><span>Subtotal</span><span data-cod-sub></span></div><div class="r disc" data-cod-discrow hidden><span data-cod-disclabel>Discount</span><span data-cod-disc></span></div><div class="r"><span>Shipping</span><span data-cod-ship></span></div><div class="r tot"><span>Total (COD)</span><span data-cod-total></span></div></div>' +
          '<button class="cod-submit" type="button" data-cod-submit><span class="cod-spin"></span><span class="cod-submit__t"></span></button>' +
          '<div class="cod-trust"><span><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>Secure</span><span><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z" stroke-linejoin="round"/><circle cx="7" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/></svg>Cash on delivery</span><span>No advance payment</span></div>' +
        '</div>' +
        '<div class="cod-success"><div class="cod-success__ic"><svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></div><h3>Order placed!</h3><p></p><button type="button" data-cod-close>Continue shopping</button></div>' +
      '</div>';
    document.body.appendChild(MODAL);

    EL = {
      card: MODAL.querySelector('.cod-modal__card'),
      h3: MODAL.querySelector('.cod-head__t h3'), sub: MODAL.querySelector('.cod-head__t p'),
      img: MODAL.querySelector('.cod-prod img'), title: MODAL.querySelector('.cod-prod__i b'),
      pvar: MODAL.querySelector('.cod-prod__i .cod-var'), now: MODAL.querySelector('.cod-prod__p .now'), was: MODAL.querySelector('.cod-prod__p .was'),
      variants: MODAL.querySelector('.cod-variants'), offers: MODAL.querySelector('.cod-offers'),
      qty: MODAL.querySelector('[data-cod-qty]'), province: MODAL.querySelector('[data-cod-province]'), provinceSel: MODAL.querySelector('select[name=province]'),
      email: MODAL.querySelector('[data-cod-email]'), notes: MODAL.querySelector('[data-cod-notes]'),
      form: MODAL.querySelector('.cod-form'), msg: MODAL.querySelector('.cod-msg'),
      subEl: MODAL.querySelector('[data-cod-sub]'), shipEl: MODAL.querySelector('[data-cod-ship]'), totalEl: MODAL.querySelector('[data-cod-total]'),
      coupon: MODAL.querySelector('[data-cod-coupon]'), codeInput: MODAL.querySelector('[data-cod-code]'),
      applyBtn: MODAL.querySelector('[data-cod-apply]'), couponMsg: MODAL.querySelector('[data-cod-coupon-msg]'),
      discRow: MODAL.querySelector('[data-cod-discrow]'), discEl: MODAL.querySelector('[data-cod-disc]'),
      discLabel: MODAL.querySelector('[data-cod-disclabel]'),
      submit: MODAL.querySelector('[data-cod-submit]'), submitT: MODAL.querySelector('.cod-submit__t'),
      successP: MODAL.querySelector('.cod-success p'),
      body: MODAL.querySelector('.cod-body')
    };

    // events
    MODAL.addEventListener('click', function (e) { if (e.target.closest('[data-cod-close]')) close(); });
    MODAL.querySelector('[data-cod-dec]').addEventListener('click', function () { setQty(state.qty - 1); });
    MODAL.querySelector('[data-cod-inc]').addEventListener('click', function () { setQty(state.qty + 1); });
    EL.qty.addEventListener('input', function () { setQty(parseInt(EL.qty.value, 10) || 1, true); });
    EL.applyBtn.addEventListener('click', function () { state.coupon ? clearCoupon(true) : applyCoupon(); });
    EL.codeInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); if (!state.coupon) applyCoupon(); }
    });
    // typing a new code after one is applied drops the old one so the totals can never lie
    EL.codeInput.addEventListener('input', function () { if (state.coupon) clearCoupon(false); });
    EL.submit.addEventListener('click', submit);
    // scroll affordances: elevate the footer + reveal a "more below" cue so users know the form scrolls
    if (EL.body) EL.body.addEventListener('scroll', updateScrollHints, { passive: true });
    window.addEventListener('resize', function () { if (MODAL && MODAL.classList.contains('open')) updateScrollHints(); });
    // live per-field validation: check on blur, and clear the error live once flagged
    EL.form.querySelectorAll('[name]').forEach(function (inp) {
      if (inp.name === 'company') return;
      inp.addEventListener('blur', function () { validateField(inp); });
      inp.addEventListener('input', function () { var w = inp.closest('.cod-field'); if (w && w.classList.contains('err')) validateField(inp); });
    });
    var phoneInput = EL.form.querySelector('[name=phone]');
    if (phoneInput) { phoneInput.setAttribute('maxlength', '18'); phoneInput.addEventListener('input', function () { this.value = this.value.replace(/[^\d+\-\s]/g, ''); }); }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && MODAL.classList.contains('open')) close(); });
  }

  /* ---------- open with a given config ---------- */
  function open(cfg) {
    CFG = cfg; buildModal();
    var p = CFG.product;
    state.variant = p.variants.filter(function (v) { return v.id == p.selected_variant; })[0] || p.variants[0];
    state.qty = 1; state.offer = null; state.coupon = null; state.couponBusy = false;

    EL.h3.textContent = CFG.heading || 'Complete your order';
    EL.sub.textContent = CFG.sub || '';
    EL.title.textContent = p.title;
    EL.submitT.textContent = CFG.cta || 'Confirm Order';

    // variant pills (only if >1 real variant)
    EL.variants.innerHTML = '';
    if (p.variants.length > 1) {
      p.variants.forEach(function (v) {
        var b = document.createElement('button'); b.type = 'button'; b.textContent = v.title;
        if (!v.available) b.disabled = true;
        b.addEventListener('click', function () { if (v.available) { state.variant = v; render(); } });
        EL.variants.appendChild(b);
      });
    }
    // province
    EL.province.style.display = CFG.ask_province ? '' : 'none';
    if (CFG.ask_province) {
      EL.provinceSel.innerHTML = '<option value="">Select…</option>' + (CFG.provinces || []).map(function (pr) { return '<option>' + pr.trim() + '</option>'; }).join('');
    }
    EL.email.style.display = CFG.ask_email ? '' : 'none';
    EL.notes.style.display = CFG.ask_notes ? '' : 'none';

    // offers
    var offers = parseOffers(CFG.offers);
    EL.offers.innerHTML = '';
    offers.forEach(function (o) {
      var d = document.createElement('button'); d.type = 'button'; d.className = 'cod-offer'; d.dataset.qty = o.qty;
      d.dataset.label = o.label; d.dataset.tag = o.tag || '';
      d.innerHTML = '<span class="cod-offer__q">Buy ' + o.qty + '</span>'
        + '<span class="cod-offer__l"' + (claimsFreeShip(o.label) ? ' data-cod-freeclaim' : '') + '>' + o.label + '</span>'
        + (o.tag ? '<span class="cod-offer__tag"' + (claimsFreeShip(o.tag) ? ' data-cod-freeclaim' : '') + '>' + o.tag + '</span>' : '')
        + '<span class="cod-offer__p">' + money(state.variant.price * o.qty) + '</span>';
      d.addEventListener('click', function () { setQty(o.qty); });
      EL.offers.appendChild(d);
    });

    render();
    MODAL.classList.remove('done');
    EL.msg.classList.remove('show'); EL.form.reset();
    document.documentElement.classList.add('cod-lock'); document.body.classList.add('cod-lock');
    EL.card.querySelector('.cod-body').scrollTop = 0;
    requestAnimationFrame(function () { MODAL.classList.add('open'); updateScrollHints(); });
    setTimeout(updateScrollHints, 380);
    setTimeout(function () { var f = EL.form.querySelector('[name=name]'); if (f) try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }, 340);
  }
  function close() {
    MODAL.classList.remove('open');
    document.documentElement.classList.remove('cod-lock'); document.body.classList.remove('cod-lock');
  }
  // Toggle scroll cues on the card: shadow under the header once scrolled, and a fade +
  // stronger footer elevation while there are more fields below the fold. Lets users see
  // at a glance that the form scrolls and there's more to fill.
  function updateScrollHints() {
    var b = EL.body, c = EL.card;
    if (!b || !c) return;
    c.classList.toggle('is-scrolled', b.scrollTop > 2);
    c.classList.toggle('has-more-below', b.scrollTop + b.clientHeight < b.scrollHeight - 4);
  }

  /* ---------- discount code ---------- */
  function couponUI() {
    var applied = !!state.coupon;
    EL.coupon.classList.toggle('is-applied', applied);
    EL.codeInput.readOnly = applied;
    EL.applyBtn.textContent = state.couponBusy ? 'Checking…' : (applied ? 'Remove' : 'Apply');
    EL.applyBtn.disabled = state.couponBusy;
  }
  function couponMsg(text, kind) {
    EL.couponMsg.textContent = text || '';
    EL.couponMsg.className = 'cod-coupon__msg' + (text ? ' show ' + (kind || '') : '');
  }
  function clearCoupon(alsoClearInput) {
    state.coupon = null;
    if (alsoClearInput) { EL.codeInput.value = ''; EL.codeInput.focus(); }
    couponMsg('', ''); couponUI(); render();
  }
  function applyCoupon() {
    var code = (EL.codeInput.value || '').trim().toUpperCase();
    EL.codeInput.value = code;
    if (!code) { couponMsg('Enter a discount code', 'err'); EL.codeInput.focus(); return; }
    if (state.couponBusy) return;
    state.couponBusy = true; couponMsg('', ''); couponUI();
    fetch(String(CFG.endpoint).replace(/\/+$/, '') + '/coupon', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: code, variant_id: state.variant.id, quantity: state.qty })
    })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .then(function (d) {
        state.couponBusy = false;
        if (d && d.ok) {
          // popup maths is in cents throughout, so take the cents figure the worker returns
          state.coupon = { code: d.code || code, amount: parseFloat(d.amount_cents) || 0, freeShipping: !!d.freeShipping };
          couponMsg(state.coupon.freeShipping ? 'Free shipping applied' : 'Code applied', 'ok');
        } else {
          state.coupon = null;
          couponMsg((d && d.error) || 'That code is not valid', 'err');
        }
        couponUI(); render();
      })
      .catch(function () {
        state.couponBusy = false; state.coupon = null;
        couponMsg('Could not check that code. Please try again.', 'err');
        couponUI(); render();
      });
  }
  // The discount depends on quantity and variant, so a change must re-check it with the server
  // rather than keep a stale amount on screen.
  function revalidateCoupon() {
    if (!state.coupon || state.couponBusy) return;
    var code = state.coupon.code;
    state.coupon = null; render();
    EL.codeInput.value = code;
    applyCoupon();
  }

  function setQty(q, fromInput) {
    q = Math.max(1, Math.min(999, q || 1));
    var changed = q !== state.qty;
    state.qty = q;
    if (!fromInput) EL.qty.value = q;
    render();
    if (changed) revalidateCoupon();
  }

  /* ---------- render prices/totals/selection ---------- */
  function render() {
    var v = state.variant, p = CFG.product;
    EL.img.src = (v && v.image) || p.image; EL.img.alt = p.title;
    EL.pvar.textContent = (p.variants.length > 1 && v && v.title !== 'Default Title') ? v.title : '';
    EL.now.textContent = money(v.price);
    if (v.compare_at && v.compare_at > v.price) { EL.was.textContent = money(v.compare_at); EL.was.style.display = ''; }
    else EL.was.style.display = 'none';
    // variant pills state
    [].forEach.call(EL.variants.children, function (b) { b.setAttribute('aria-pressed', b.textContent === v.title); });
    // offers selection + keep each tier's price in sync with the chosen variant
    [].forEach.call(EL.offers.children, function (d) {
      var q = parseInt(d.dataset.qty, 10);
      d.classList.toggle('sel', q === state.qty);
      d.setAttribute('aria-pressed', q === state.qty);
      var pe = d.querySelector('.cod-offer__p'); if (pe) pe.textContent = money(v.price * q);
      // A tier only earns the "free shipping" line if its own total actually clears the
      // threshold. Rs 990 x 2 = Rs 1,980 is under Rs 2,000, so the promise is hidden there.
      var earnsFree = shipFor(v.price * q) === 0;
      [].forEach.call(d.querySelectorAll('[data-cod-freeclaim]'), function (n) {
        n.style.display = earnsFree ? '' : 'none';
      });
      var lbl = claimsFreeShip(d.dataset.label) && !earnsFree ? '' : (d.dataset.label || '');
      d.setAttribute('aria-label', 'Buy ' + q + (lbl ? ' \u2014 ' + lbl : ''));
    });
    EL.qty.value = state.qty;
    // totals
    var subtotal = v.price * state.qty;
    var ship = shipFor(subtotal);
    // discount (server-validated amount; free-shipping codes zero the shipping line instead)
    var disc = 0;
    if (state.coupon) {
      if (state.coupon.freeShipping) ship = 0;
      else disc = Math.min(state.coupon.amount, subtotal);
    }
    EL.subEl.textContent = money(subtotal);
    if (state.coupon && (disc > 0 || state.coupon.freeShipping)) {
      EL.discRow.hidden = false;
      EL.discLabel.textContent = 'Discount (' + state.coupon.code + ')';
      EL.discEl.textContent = state.coupon.freeShipping ? 'Free shipping' : ('−' + money(disc));
    } else { EL.discRow.hidden = true; }
    if (ship === 0) { EL.shipEl.textContent = 'FREE'; EL.shipEl.className = 'free'; }
    else { EL.shipEl.textContent = money(ship); EL.shipEl.className = ''; }
    EL.totalEl.textContent = money(Math.max(0, subtotal - disc) + ship);
    state._ship = ship; state._subtotal = subtotal; state._discount = disc;
    couponUI();
  }

  /* ---------- validation + submit ---------- */
  // Pakistani mobile only: 03XX-XXXXXXX (accepts +92 / 92 / bare 3XX…). Landlines/short numbers rejected.
  function normPk(v) { var d = String(v || '').replace(/\D/g, ''); if (d.indexOf('92') === 0) d = '0' + d.slice(2); else if (d.length === 10 && d.charAt(0) === '3') d = '0' + d; return d; }
  function validPkPhone(v) { return /^03\d{9}$/.test(normPk(v)); }
  function validEmail(v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v); }
  function fieldError(f) {
    if (!f) return '';
    var v = (f.value || '').trim();
    switch (f.name) {
      case 'name': return v.length >= 2 ? '' : 'Please enter your full name';
      case 'phone': return validPkPhone(v) ? '' : 'Enter a valid Pakistani mobile — e.g. 0300 1234567';
      case 'address': return v.length >= 6 ? '' : 'Please enter your complete address';
      case 'city': return v.length >= 2 ? '' : 'Please enter your city';
      case 'email': return !v ? 'Please enter your email address' : (validEmail(v) ? '' : 'Please enter a valid email address');
      default: return '';
    }
  }
  function validateField(f) {
    var err = fieldError(f), wrap = f && f.closest('.cod-field');
    if (!wrap) return !err;
    wrap.classList.toggle('err', !!err);
    if (err) { var e = wrap.querySelector('.cod-field__err'); if (e) e.textContent = err; }
    return !err;
  }
  function submit() {
    if (state.busy) return;
    var f = EL.form;
    if (f.company.value) return; // honeypot tripped — silently drop
    var fields = ['name', 'phone', 'address', 'city'];
    if (f.email && EL.email && EL.email.style.display !== 'none') fields.push('email');
    var ok = true;
    fields.forEach(function (n) { if (f[n]) ok = validateField(f[n]) && ok; });
    if (!ok) {
      EL.msg.textContent = 'Please fix the highlighted fields.';
      EL.msg.classList.add('show');
      var firstErr = EL.form.querySelector('.cod-field.err input, .cod-field.err textarea');
      if (firstErr) try { firstErr.focus(); } catch (e) {}
      return;
    }
    EL.msg.classList.remove('show');

    if (!CFG.endpoint) { EL.msg.textContent = 'Order backend not configured yet.'; EL.msg.classList.add('show'); return; }

    var custName = f.name.value.trim();
    var payload = {
      variant_id: state.variant.id, quantity: state.qty,
      name: custName, phone: normPk(f.phone.value), address: f.address.value.trim(), city: f.city.value.trim(),
      province: f.province ? f.province.value : '', email: f.email ? f.email.value.trim() : '',
      notes: f.notes ? f.notes.value.trim() : '',
      product_title: CFG.product.title, shipping: state._ship,
      discount_code: state.coupon ? state.coupon.code : ''
    };
    state.busy = true; EL.submit.classList.add('loading'); EL.submit.disabled = true;
    fetch(CFG.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok && res.j && res.j.ok) {
          // build with textContent for the user/server values (no innerHTML injection)
          EL.successP.innerHTML = 'Thank you, <b class="cod-nm"></b>! Your order <span class="ord"></span> is confirmed. A confirmation email is on its way, and your tracking ID will follow by email once your order ships. Pay cash on delivery.';
          EL.successP.querySelector('.cod-nm').textContent = custName.split(/\s+/)[0];
          EL.successP.querySelector('.ord').textContent = res.j.order_name || '';
          MODAL.classList.add('done');
        } else {
          EL.msg.textContent = (res.j && res.j.error) || 'Could not place the order. Please try again or WhatsApp us.';
          EL.msg.classList.add('show');
        }
      })
      .catch(function () { EL.msg.textContent = 'Network error. Please try again.'; EL.msg.classList.add('show'); })
      .finally(function () { state.busy = false; EL.submit.classList.remove('loading'); EL.submit.disabled = false; });
  }

  /* ---------- init: wire each product's open button ---------- */
  function init() {
    document.querySelectorAll('[data-cod-config]').forEach(function (script) {
      var cfg; try { cfg = JSON.parse(script.textContent); } catch (e) { return; }
      var scope = script.closest('.product-form, product-form, form, .product__info-container') || document;
      var btn = scope.querySelector('[data-cod-open]') || (script.previousElementSibling && script.previousElementSibling.matches('[data-cod-open]') ? script.previousElementSibling : null);
      if (!btn || btn.__codWired) return; btn.__codWired = true;
      btn.addEventListener('click', function () {
        // sync the currently-selected variant from the product form if present
        var idInput = scope.querySelector('[name="id"]');
        if (idInput && idInput.value) cfg.product.selected_variant = idInput.value;
        open(cfg);
      });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
